import React, { useState, FormEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Formulario, { FormField } from "../../../../components/Formulario";
import { createModelo } from "../../../../api/modeloApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getFabricantes } from "../../../../api/fabricanteApi";
import { getEmpresas } from "../../../../api/empresaApi";
import { Fabricante } from "../../../../types/acao";
import { Empresa } from "../../../../types/empresas";

const AdicionarModelo: React.FC = () => {
  const [descricaoModelo, setDescricaoModelo] = useState<string>("");
  const [idFabricante, setIdFabricante] = useState<Fabricante | null>(null);
  const [fabricantes, setFabricantes] = useState<Fabricante[]>([]);
  const [idEmpresa, setIdEmpresa] = useState<Empresa | null>(null);
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFabricantes = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const fabricantesData = await getFabricantes(token);
        setFabricantes(fabricantesData);
      } catch (error) {
        toast.error("Erro ao buscar fabricante!");
        console.error("Erro ao buscar fabricante:", error);
      }
    };
    const fetchEmpresas = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const empresasData = await getEmpresas(token);
        setEmpresas(empresasData);
      } catch (error) {
        toast.error("Erro ao buscar empresas!");
        console.error("Erro ao buscar empresas:", error);
      }
    };

    fetchFabricantes();
    fetchEmpresas();
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      if (!idFabricante) {
        toast.error("Selecione um fabricante!");
        setLoading(false);
        return;
      }
      
      if (!idEmpresa) {
        toast.error("Selecione uma empresa!");
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("descricao_modelo", descricaoModelo);
      formData.append("id_fabricante", idFabricante ? idFabricante.id.toString() : "");
      formData.append("id_empresa", idEmpresa.id.toString());
      
      await createModelo(token, formData);
      toast.success("Modelo criado com sucesso!");
      navigate("/modelos");
    } catch (error) {
      toast.error("Erro ao adicionar modelo!");
      console.error("Erro ao adicionar modelo:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleFabricanteChange = (event: React.SyntheticEvent, value: Fabricante) => {
    setIdFabricante(value);
  };

  const handleEmpresaChange = (event: React.SyntheticEvent, value: Empresa) => {
    setIdEmpresa(value);
  };

  const fields: FormField[] = [
    {
      label: "Descrição do Modelo",
      type: "text",
      value: descricaoModelo,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setDescricaoModelo(e.target.value),
    },
    {
      label: "Fabricante",
      type: "autocomplete",
      value: idFabricante,
      required: true,
      onChangeAutocomplete: handleFabricanteChange,
      options: fabricantes,
      getOptionLabel: (option: Fabricante) => option.descricao_fabricante,
    },
    {
      label: "Empresa",
      type: "autocomplete",
      value: idEmpresa,
      required: true,
      onChangeAutocomplete: handleEmpresaChange,
      options: empresas,
      getOptionLabel: (option: Empresa) => option.nome_empresa,
    },
  ];

  return (
    <Formulario
      title="Adicionar Modelo"
      fields={fields}
      onSubmit={handleSubmit}
      loading={loading}
      onBack={handleBack}
    />
  );
};

export default AdicionarModelo;
